import {
  IonButton,
  IonCard,
  IonIcon,
  IonLabel,
  useIonRouter,
} from "@ionic/react";
import moment from "moment";
import { useState } from "react";
import { ellipsisHorizontalOutline } from "ionicons/icons";

import "./styles.css";

import MoreModal from "./MoreModal";
import { Cow } from "../../../../models";

interface CowCardProps {
  cow: Cow;
}

const CowCard = ({ cow }: CowCardProps) => {
  const router = useIonRouter();
  const [isMoreOpen, setIsMoreOpen] = useState(false);

  const onCardClicked = (e: any) => {
    if (e.target.id === "more") {
      return setIsMoreOpen(true);
    }

    router.push(`/cows/${cow.id}`, "forward");
  };

  const getColor = () => {
    const today = moment();

    if (
      cow.lastVaccineDate &&
      today.diff(moment(cow.lastVaccineDate, "MM/DD/YYYY"), "days") <= 14
    )
      return "#4169e1";

    return "#000";
  };

  return (
    <div>
      <IonCard
        className="CowCard"
        onClick={(e) => onCardClicked(e)}
        style={{
          border: `1px solid ${
            getColor() === "#000" ? "transparent" : getColor()
          }`,
        }}
      >
        <div className={"CowCardData"}>
          <h4>{cow.cowName}</h4>
          <IonLabel>{cow.location}</IonLabel>
        </div>
        <IonButton fill="clear" id="more" className="CowMore" size={"small"}>
          <IonIcon icon={ellipsisHorizontalOutline} size="small" />
        </IonButton>
      </IonCard>
      <MoreModal
        cowId={cow.id}
        isOpen={isMoreOpen}
        close={() => setIsMoreOpen(false)}
      />
    </div>
  );
};

export default CowCard;
